// extracted by mini-css-extract-plugin
export default {"navbar":"uIA48BW9eu5BE19EhjAA","section":"Bt5GeJeTeIdF5qBeVfSS","threads":"Fe5eTEzkGJYVO9kJestq","threadsHeader":"Err6plu2x97pFXOVuLIl","threadLinkInfo":"bK24tnBYeu8KHkE6GE1H"};